import LeftSideBottomBar from '@src/routes/Configurators/components/LeftSideBottomBar'
import { useRouter } from 'next/router'
import MyOligosList from './MyOligoList'
import {
  useProductFromQueryParam,
  TabsEnum,
  myOligoTitle,
  myOligoBodyContent,
} from './ProductsConfiguration'
import useFormikHelper from './useFormikHelper'
import { Box } from '@material-ui/core'

import { BiTubeProduct } from '../BiTube/enum'
import { TubeProperties } from '../../utils/StandardMTOEnum'

interface MyOligosSideSectionProps {
  handleAddOligo: () => void
  disableAddNextLinks: boolean
}
const MyOligosSideSection = ({
  handleAddOligo,
  disableAddNextLinks,
}: MyOligosSideSectionProps) => {
  const { query } = useRouter()
  const activeLink = query.activeLink || TabsEnum.SequenceEntry
  const product = useProductFromQueryParam()
  const formik = useFormikHelper()
  const isMirna = product === BiTubeProduct.mirna

  const nameType = isMirna ? TubeProperties.AntiSenseName : TubeProperties.Name

  const oligoList = formik.allValues?.oligoList
  let oligoCount = 0
  if (oligoList) {
    if (oligoList.length === 1) {
      const firstOligo = oligoList[0]
      const nameValue = firstOligo[nameType]
      // Check if firstOligo and the dynamic property exists
      const hasName = typeof nameValue === 'string' && nameValue.length > 0
      const hasSequence =
        firstOligo.sequence &&
        typeof firstOligo.sequence === 'string' &&
        firstOligo.sequence.length > 0

      oligoCount = hasName || hasSequence ? 1 : 0
    } else {
      oligoCount = oligoList.length
    }
  }

  const handleDeleteAll = () => {
    formik.removeItemFromOligoList(null, true)
  }

  const enableMyOligos =
    !!(
      formik.allValues?.oligoList?.length === 1 &&
      formik.allValues?.oligoList[0]?.[nameType]?.trim()
    ) || formik.allValues?.oligoList?.length > 1
  return activeLink === TabsEnum.SequenceEntry ? (
    <LeftSideBottomBar
      title={myOligoTitle(product)}
      bodyContent={
        enableMyOligos ? (
          <MyOligosList />
        ) : (
          <Box> {myOligoBodyContent(product)} </Box>
        )
      }
      handleAddOligo={handleAddOligo}
      disableAddNextLinks={disableAddNextLinks}
      enableDeleteAll={enableMyOligos}
      handleDeleteAll={handleDeleteAll}
      oligoCount={oligoCount}
    />
  ) : (
    <></>
  )
}

export default MyOligosSideSection
